<template>
  <v-app>
    <BrowserWarning />
    <!-- for a very brief time when the home page is loading, $route.name is undefined -->
    <MenuBar
      v-if="$route.name && $route.name !== 'home'"
      style="z-index: 999;"
      @showBottomDrawer="bottomDrawerShown = true"
      @showPlanDialog="planOptionsDialogShown = true"
    />
    <v-content>
      <router-view
        @showBottomDrawer="bottomDrawerShown = true"
        @showPlanDialog="planOptionsDialogShown = true"
      />
    </v-content>
    <v-bottom-sheet v-model="bottomDrawerShown">
      <BottomDrawer @close="bottomDrawerShown = false" />
    </v-bottom-sheet>
    <v-dialog v-model="planOptionsDialogShown">
      <PlanOptions
        @close="planOptionsDialogShown = false"
        @createFreeAccount="planOptionsDialogShown = false"
      />
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';

import NeuralikeBottomDrawer from '@/layout/BottomDrawer/NeuralikeBottomDrawer.vue';
import OpenvoxelBottomDrawer from '@/layout/BottomDrawer/OpenvoxelBottomDrawer.vue';
import BrowserWarning from '@/layout/BrowserWarning.vue';
import MenuBar from '@/layout/MenuBar.vue';
import PlanOptions from '@/components/Home/PlanOptions.vue';

const theme = process.env.VUE_APP_THEME;

export default {
  name: 'App',
  components: {
    BottomDrawer: theme === 'openvoxel' ? OpenvoxelBottomDrawer : NeuralikeBottomDrawer,
    PlanOptions,
    BrowserWarning,
    MenuBar,
  },
  data() {
    return {
      bottomDrawerShown: false,
      planOptionsDialogShown: false,
    };
  },
  async created() {
    try {
      await this.initializeUser();
    } catch (e) {
      // noop
    }
    this.loadNiftiUrl({
      // TODO: read this from sampleFiles (probably via a call to ImagePicker or a Vuex module)
      fileUrl: 'https://s3.amazonaws.com/neuralike-samples/sample_2_anatomical.nii.gz',
    });
  },
  methods: {
    ...mapActions('image', [
      'loadNiftiUrl',
    ]),
    ...mapActions('auth', [
      'initializeUser',
    ]),
  },
};
</script>
